// ============================================
// LABELS MÉTIER
// ============================================
// Libellés français des énumérations, et configuration des rôles.
// Extrait de AdminV2.tsx.

import React from 'react';
import { ShieldCheck, UserCog, Headphones, User } from 'lucide-react';
import { TicketStatus, TicketPriority, IssueType, UserRole } from '../types';

// ============================================
// LABELS
// ============================================

export const STATUS_LABELS: Record<TicketStatus, string> = {
  [TicketStatus.OPEN]: 'Ouvert',
  [TicketStatus.IN_PROGRESS]: 'En cours',
  [TicketStatus.WAITING_CUSTOMER]: 'Attente client',
  [TicketStatus.RESOLVED]: 'Résolu',
  [TicketStatus.CLOSED]: 'Fermé',
  [TicketStatus.ESCALATED]: 'Escaladé',
  [TicketStatus.REOPENED]: 'Réouvert',
};

export const PRIORITY_LABELS: Record<TicketPriority, string> = {
  [TicketPriority.LOW]: 'Basse',
  [TicketPriority.MEDIUM]: 'Moyenne',
  [TicketPriority.HIGH]: 'Haute',
  [TicketPriority.URGENT]: 'Urgente',
};

export const ISSUE_TYPE_LABELS: Record<IssueType, string> = {
  [IssueType.TECHNICAL]: 'Technique',
  [IssueType.DELIVERY]: 'Livraison',
  [IssueType.BILLING]: 'Facturation',
  [IssueType.OTHER]: 'Autre',
};

// ============================================
// CONFIGURATION DES RÔLES
// ============================================

export const ROLE_CONFIG: Record<string, { label: string; color: string; icon: React.ReactNode; permissions: string[] }> = {
  [UserRole.ADMIN]: { label: 'Administrateur', color: 'bg-purple-100 text-purple-800', icon: <ShieldCheck className="w-4 h-4" />, permissions: ['*'] },
  [UserRole.SUPERVISOR]: { label: 'Superviseur', color: 'bg-blue-100 text-blue-800', icon: <UserCog className="w-4 h-4" />, permissions: ['tickets', 'assign', 'reports', 'team'] },
  [UserRole.AGENT]: { label: 'Agent', color: 'bg-green-100 text-green-800', icon: <Headphones className="w-4 h-4" />, permissions: ['tickets', 'messages', 'customers'] },
  [UserRole.CUSTOMER]: { label: 'Client', color: 'bg-brume text-encre', icon: <User className="w-4 h-4" />, permissions: ['tickets.own'] },
};
